import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import { LoadingSpinner } from './LoadingSpinner'
import { useEffect } from 'react'

interface ProtectedRouteProps {
  children: React.ReactNode
  requiredRole?: string
}

export function ProtectedRoute({ children, requiredRole }: ProtectedRouteProps) {
  const { user, profile, loading } = useAuth()
  const location = useLocation()

  // Store current path when redirecting to login
  useEffect(() => {
    if (!loading && !user && location.pathname !== '/login') {
      sessionStorage.setItem('redirectAfterAuth', location.pathname)
    }
  }, [loading, user, location])

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <LoadingSpinner />
      </div>
    )
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  // Wait for profile to load before checking roles
  if (!profile && requiredRole) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <LoadingSpinner />
      </div>
    )
  }

  if (requiredRole && profile?.role !== requiredRole && profile?.role !== 'admin') {
    // Don't redirect admins or users with the correct role
    return <Navigate to="/" replace />
  }

  return <>{children}</>
}